export default __webpack_public_path__ + "static/media/professional.ef858eb6.svg";